// extracted by mini-css-extract-plugin
module.exports = {"newList":"NewListButton_newList__2axt2","disabled":"NewListButton_disabled__1GTQT"};